import { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import * as galleryAction from './gallery.action';

const useGallery = () => {
	const dispatch = useDispatch();

	const gallery = useSelector((state:any) => {
		return state.galleryReducer;
	});

	const setPhotos = useCallback(
		(payload:any) => {
			dispatch(galleryAction.setPhotos(payload));
		},
		[dispatch],
	);

	const setPaginationOption = useCallback(
		(payload:any) => {
			dispatch(galleryAction.setPaginationOption(payload));
		},
		[dispatch],
	);

	return { gallery, setPhotos, setPaginationOption };
};

export default useGallery;